import { render, staticRenderFns } from "./LeaderboardVisibilityToggle.vue?vue&type=template&id=b0f27ee6&scoped=true&"
import script from "./LeaderboardVisibilityToggle.vue?vue&type=script&lang=js&"
export * from "./LeaderboardVisibilityToggle.vue?vue&type=script&lang=js&"
import style0 from "./LeaderboardVisibilityToggle.vue?vue&type=style&index=0&id=b0f27ee6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0f27ee6",
  null
  
)

export default component.exports